import { lazy } from 'react';
import { authRoleAccess } from '../../auth/AuthRoleAccess';

const ReportsHub = lazy(() => import('./ReportsHub'));
const FinancialReports = lazy(() => import('./FinancialReports'));
const StockReports = lazy(() => import('./StockReports'));
const OrderReports = lazy(() => import('./OrderReports'));
const MenuItemReports = lazy(() => import('./MenuItemReports'));

export const ReportsRoutes = [
    { path: '/reports', component: ReportsHub, auth: authRoleAccess.reports },
    { path: '/reports/financial', component: FinancialReports, auth: authRoleAccess.reports },
    { path: '/reports/stocks', component: StockReports, auth: authRoleAccess.reports },
    { path: '/reports/orders', component: OrderReports, auth: authRoleAccess.reports },
    { path: '/reports/menu-items', component: MenuItemReports, auth: authRoleAccess.reports },
];

export default ReportsRoutes;

